import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Ordinal } from 'atoms/typography/Ordinal';

const StyledSup = styled.sup`
  font-size: var(--fs-12);
`;

type Props = {
  liveRankingRatio: number;
  liveRanking: number;
};

export const RankingRatio = ({ liveRankingRatio, liveRanking }: Props) => {
  const showDash = liveRankingRatio === 0 && liveRanking === 0;

  const showRatio = !showDash && liveRankingRatio > 0 && liveRanking > 20;
  const showOrdinal = !showDash && !showRatio;

  return (
    <>
      {!!showDash && '-'}
      {!!showRatio && (
        <FormattedMessage
          id="Collections.RankingRatio.liveRankingRatio"
          defaultMessage="Top {liveRankingRatio}%"
          values={{ liveRankingRatio }}
        />
      )}
      {!!showOrdinal && (
        <>
          {liveRanking > 0 ? (
            <Ordinal ordinal={liveRanking} Sup={StyledSup} />
          ) : (
            '-'
          )}
        </>
      )}
    </>
  );
};
